import { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';

interface BrowserInfo {
  name: string;
  version: string;
}

const useGetBrowserInfo = (): BrowserInfo => {
  const [browserInfo, setBrowserInfo] = useState<BrowserInfo>({
    name: 'Unknown',
    version: '',
  });

  useEffect(() => {
    try {
      const parser = new UAParser();
      const userAgent = parser.getBrowser();
      const browserName = userAgent?.name ?? 'Unknown';
      const browserVersion = userAgent?.version ?? '';
      setBrowserInfo({ name: browserName, version: browserVersion });
    } catch (e) {
      console.warn(e);
    }

  }, []);

  return browserInfo;
};

export default useGetBrowserInfo;
